export default {
  name: 'app',
  components: {
    //Page
  },
  created: function(){
    
    window.onhashchange = function(event){
      //console.log(event)
      var hash1 = event.oldURL.split('#')[1];
      var hash2 = event.newURL.split('#')[1];
      if (hash2 != 'sub-page') {
        $('.sub-page').hide();  
      }
    };
    
  },
  mounted: function(){
    //console.log('App:', 'mounted')
    
    //MIRASO - Slickjs
    /*
    $('.slick-miraso').slick({
       dots: false,
       //infinite: false,
       nextArrow: false,
       prevArrow: false,
       vertical: true,
       verticalSwiping: true
       
    });
    $('.slick-miraso-pagenav .pgn:nth-child(2)').addClass('selected');
    $('.slick-miraso').on('afterChange', function(event, slick, direction){
      //console.log(slick.slickCurrentSlide())
      $('.slick-miraso-pagenav .pgn').removeClass('selected');
      $('.slick-miraso-pagenav .pgn:nth-child(' + (slick.slickCurrentSlide()+2) + ')').addClass('selected');
    });
    */
    
    var isTouchscreen = "ontouchstart" in document.documentElement ? true : false;
    
    //FullPage
    $('#nav li:nth-child(1)').addClass('selected');
    if ($.fn.fullpage.destroy) $.fn.fullpage.destroy('all');
    $('#pages').fullpage({
      
      menu: '#nav > ul',
      lockAnchors: false,
      anchors:['01', '02', '03', '04', '05', '06', '07', '08', '09'],
      navigation: false,
      navigationPosition: 'right',
      navigationTooltips: ['01', '02', '03', '04', '05', '06', '07', '08', '09'],
      showActiveTooltip: false,
      slidesNavigation: false,
      slidesNavPosition: 'bottom',
      
      sectionSelector: '.page',
      
      dragAndMove: true,
      
      //autoScrolling: !isTouchscreen,
      fitToSection: !isTouchscreen,
      //autoScrolling: !isTouchscreen,
      
      afterLoad: function(origin, destination, direction){
        if (origin.anchor == '06') {
          
        } else {
          
        }
      },
      
      onLeave: function(index, nextIndex, direction){
        var nindex = '0' + String(nextIndex);
        //console.log(nindex)
        if (nindex == '02' || nindex == '03' || nindex == '04' ) nindex = '01';
        $('#nav li').removeClass('selected');
        $('#nav li[data-menuanchor='+nindex+']').addClass('selected');
        //$('#nav li:nth-child('+nextIndex+')').addClass('selected');
      }
    });
    
    
    
    ////Sub-Slick
    
    $('.sub-page > .warp > .slick-nav > div:nth-child(1)').addClass('selected');
    
    //Rollbook
    var $sub_page_rollbook = $('#sub-page-rollbook');
    $sub_page_rollbook.find('.slick').slick({
      dots: false,
      nextArrow: false,
      prevArrow: false,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '30px',
      infinite: false
    });
    
    $sub_page_rollbook.find('.slick').on('afterChange', function(event, slick, direction){
      $sub_page_rollbook.find('.slick-nav > div').removeClass('selected');
      $sub_page_rollbook.find('.slick-nav > div:nth-child(' + (slick.slickCurrentSlide()+1) + ')').addClass('selected');
    });
    
    
    //Worship
    var $sub_page_worship = $('#sub-page-worship');
    $sub_page_worship.find('.slick').slick({
      dots: false,
      nextArrow: false,
      prevArrow: false,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '30px',
      infinite: false
    });
    $sub_page_worship.find('.slick').on('afterChange', function(event, slick, direction){
      $sub_page_worship.find('.slick-nav > div').removeClass('selected');
      $sub_page_worship.find('.slick-nav > div:nth-child(' + (slick.slickCurrentSlide()+1) + ')').addClass('selected');
    });
    
    
    
  },
  methods: {
      submit: function(e){
        
        var $title = $('.request .submit > div');
        if ($title.text() != '보내기') return;
        
        var church = $('.request .form .org input').val();
        var name = $('.request .form .name input').val();
        var phone = $('.request .form .phone input').val();
        var text = $('.request .form .text input').val();
        
        //console.log(name, phone, church, text)
        //return;
        
        if (!name) {
        	alert('성명을 입력해 주세요.');
        	$('.request .form .name input').focus();
        	return;
        }
        if (!phone) {
        	alert('연락처을 입력해 주세요.');
        	$('.request .form .phone input').focus();
        	return false;
        }
        if (!church) {
        	alert('출석교회을 입력해 주세요.');
        	$('.request .form .org input').focus();
        	return false;
        }
        if (!text) {
        	alert('내용을 입력해 주세요.');
        	$('.request .form .text input').focus();
        	return false;
        }
        
        $title.text('전송중');
        
        $.ajax({
        	url: '//' + window.location.hostname + '/api/request',
        	data: {
        		church: church,
        		name: name,
        		phone: phone,
        		text: text,
        		referrer: window.query.r || 'unknown'
        	},
        	cache: false,
        	type: 'POST'
        }).done(function(data){
        	
        	$title.text('완료');
        	
        	var width = $('.request .warp').width()-30;
        	var height = -20+$('.request .form').outerHeight(true)+$('.request .submit').outerHeight(true);
        	var top = 30+$('.request .title').outerHeight(true);
        	//console.log(width, height, this.$('> .request > .title').outerHeight(true))
        	$('.request .done').css({
        		'display': 'block',
        		'width': width+'px',
        		'height': height+'px',
        		'top': top+'px',
        		'left': '15px'
        	});
        	$('.request .done > .icon').css({
        		'margin-top': (height-210)/2+15+'px'
        	});
        	$('.request .form, .request .submit').css({
        		'opacity': 0.1
        	});
        	
        	
        });
		    return false;
      },
      sub_page_close: function(e){
        /*
        console.log(e)
        if ($(e.target).attr('x-action') == 'close') {
          e.preventDefault();
          e.stopPropagation();
          $('.sub-page').hide();
        }
        */
        //$('.sub-page').hide();
        //console.log($(e.currentTarget).attr('x-action'))
        //return false;
        window.history.back();
      }
  }
}


// WEBPACK FOOTER //
// ./src/App.src.js